import { createRootRoute, Outlet } from '@tanstack/react-router'

import { Toaster } from '#/shared/ui/sonner'

function RootLayout() {
  return (
    <>
      <Outlet />
      {/* The product's toast host — the vendored save flows report through it. */}
      <Toaster />
    </>
  )
}

function NotFound() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2">
      <p className="text-2xl font-semibold">404</p>
      <p className="text-gray-500">This page does not exist.</p>
    </div>
  )
}

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
})
